<template>
  <div class="syllabus-container">
    <Header></Header>
    <div class="syllabus-body">
      <h1>Syllabus</h1>
      <section class="syllabus-intro">
        <el-table
          :data="syllabusList"
          stripe
          style="width: 100%">
          <el-table-column
            prop="date"
            label="时间"
            min-width="40%">
          </el-table-column>
          <el-table-column
            prop="content"
            label="内容"
            min-width="60%">
          </el-table-column>
        </el-table>
      </section>
      <section class="syllabus-plan">
        <h2>第一周</h2>

        <h3>课程背景介绍——王新兵</h3>
        <p>第一节：介绍 Acemap 系统以及课程四个模块背景，介绍课程教学目标，教学安排和要求等</p>

        <h3>工程学导论——孟桂娥</h3>
        <p>第一节：科学与工程师</p>
        <p>第二节：工程伦理，介绍工程师的基本素质和道德要求</p>
      </section>
      <section class="syllabus-plan">
        <h2>第三周～第七周</h2>
        <h3>分组实验1</h3>
        <p>第三周第一节：网站后端开发</p>
        <p>第三周第二节：网站前端开发</p>

        <h3>分组实验2</h3>
        <p>第四周第一节：爬虫原理与设计</p>

        <h3>分组实验3</h3>
        <p>第四周第二节：数据库创建与实践（上）</p>
        <p>第五周第一节：数据库创建与实践（下）</p>

        <h3>分组实验4</h3>
        <p>第五周第二节：文本信息检索与搜索引擎实践（上）</p>
        <p>第六周第一节：文本信息检索与搜索引擎实践（下）</p>

        <h3>分组实验5</h3>
        <p>第六周第二节：数据可视化-Gephi</p>
        <p>第七周第一节：数据可视化-Gephi</p>

        <h3>进阶模块</h3>
        <p>第七周第二节：进阶模块介绍（文献数据挖掘系统、知识图谱、知识体系、数据巡航）</p>
      </section>

    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      syllabusList: [
        {
          date: '第 1 周 - 第 2 周',
          content: '课程整体介绍、工程学导论'
        },
        {
          date: '第 3 周 - 第 7 周',
          content: '完成分组，并选定各自的学习模块，各模块开展授课和练习'
        },
        {
          date: '第 8 周 - 第 15 周',
          content: '各组完成Final Project'
        },
        {
          date: '第 16 周',
          content: '汇报，Presentation'
        }
      ]
    };
  },
};
</script>
<style lang="less" scoped>
.syllabus-container {
font-family: Source Sans Pro;
text-align: left;
  .syllabus-body {
    min-height: calc(100vh - 540px);
    width: 1080px;
    margin: 175px auto;
    h1 {
        font-weight: 900;
        font-size: 64px;
        line-height: 56px;
        color: #000000;
        margin-bottom: 64px;
        text-align: left;
    }
    .syllabus-intro {
      margin-bottom: 48px;
    }
    h2 {
        font-weight: 700;
        font-size: 32px;
        line-height: 32px;
        color: #000000;
        margin-bottom: 32px;
        text-align: left;
    }
    h3 {
        font-weight: 600;
        font-size: 24px;
        line-height: 24px;
        color: #000000;
        margin-bottom: 20px;
        text-align: left;
        margin-top: 20px;
    }
    .syllabus-plan {
      margin-bottom: 48px;
      margin-top: 32px;
      p {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 12px;
      }
      ol {
        // list-style: revert;
        padding-left: 4px;
        li {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>